<div id="not-found-container">
  <div class="not-found-content">
    <div>
      <h1>Page not Found!</h1>
      <div class="text">Of course, Not all those who wander are lost.<br>Maybe you wish to hang out here and
        ponder.<br>However, at some point you might wish to </div>
      <button mat-raised-button (click)="goBack()" class="mr-2">Go back to where you came from</button>
      <a href="/" mat-raised-button class="mr-2">Go home</a>
      <a href="https://www.imdb.com/title/tt0447987/" target="_blank" mat-raised-button>Go figure</a>
    </div>
  </div>
</div>